const key = "fake-customers";

const applicable = (resp) => {
	// api/businesses/${businessId}/customers?entityId=${entityId}
	const matches = (resp.config.method === "GET" || resp.config.method === "POST") 
		&& (
			resp.config.url.match(/api\/businesses\/[0-9]*\/customers$/)
			|| resp.config.url.match(/api\/businesses\/[0-9]*\/customers\?entityId=[0-9]*$/)
		);
	
	return matches;
};

const modify = (resp) => {
	if(resp.status !== 404 && resp.status !== 403 && resp.status !== 405) {
		throw resp;
	}

	resp.status = 200;
	resp.data.Success = true;
	delete resp.data.Errors;
	delete resp.data.Informations;
	
	if(resp.config.method === "GET") {
		resp.data.Data = [
		];
	}

	if(resp.config.method === "POST") {
		resp.data.Data = {
			...resp.config?.data,
			Id: 1103
		};
	}

	return resp;
};

export const fakeCustomers = [key, applicable, modify];